import { CircleDot } from "lucide-react";

export const SettingsSaveDock = ({ children, description, message }) => (
  <div className="settings-save-dock" data-testid="sticky-save-bar">
    <div className="min-w-0">
      <div className="flex items-center gap-2 text-xs font-semibold text-cyan-300">
        <CircleDot className="h-3.5 w-3.5" />
        <span>{description}</span>
      </div>
      {message?.text && (
        <p className={`mt-1 truncate text-xs ${message.type === "success" ? "text-emerald-300" : "text-red-300"}`} data-testid="settings-message" role={message.type === "success" ? "status" : "alert"}>
          {message.text}
        </p>
      )}
    </div>
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">{children}</div>
  </div>
);